module.exports = __webpack_public_path__ + "media/04 custom.97dbbedb.mp3";